export default __webpack_public_path__ + "static/media/sj-2-rMAX.c2b8231e.avif";